import React, { Component } from "react";
import { connect } from "react-redux";

//import { fetchLatestResources } from "Thunks";
import { resetResources, setCurrentNavPage } from "Actions";
import {
  TTP_WEBTOOL_URL,
  TTP_EBOX_URL,
  TTP_ACCOUNTING_URL,
  TTP_BILLTOBOX_URL,
  TTP_HOME_URL
} from "Config";

import PelletContainer from "./Pellet/PelletContainer";
import DirectoryContainer from "./Directory/DirectoryContainer";
import SearchContainer from "./Search/SearchContainer";
import DashboardContainer from "./Dashboard/DashboardContainer";
import EboxContainer from "../Common/Ebox/EboxContainer";
import WebtoolContainer from "../Common/Webtool/WebtoolContainer";

import styles from "./WorkPlace.local.scss";
import classnames from "classnames";
import _ from "i18n";

import Header from "./Header";

//import _ from "i18n";

export class WorkPlace extends Component {
  componentDidMount() {
    this.props.setCurrentNavPage("WORK_PLACE_PAGE");
  }

  render() {
    const { community, visibleAreas } = this.props;

    const { pellet, directory, dashboard } = visibleAreas;

    return (
      <div className={styles.main}>
        <Header community={community} />
        <SearchContainer community={community} />
        <section className="grid-x">
          <div
            className={classnames(
              `cell small-12 ${!directory ? "" : "large-6"}`,
              styles.section
            )}
            style={pellet ? {} : { display: "none" }}
          >
            <div className={styles.sectionArea}>
              <div
                className={classnames(styles.sectionHeader, styles.rightbtn)}
              >
                <div className={styles.headTitle}>
                  <h3>{_("Electronic invoices")}</h3>
                  <span>{_("Bill to box")}</span>
                </div>
                <a
                  href={TTP_BILLTOBOX_URL}
                  target="_blanck"
                  className={styles.button}
                >
                  {_("See more")}
                </a>
              </div>
              <div className={styles.sectionBody}>
                <PelletContainer community={community} />
              </div>
            </div>
          </div>
          <div
            className={classnames(
              `cell small-12 ${!pellet ? "" : "large-6"}`,
              styles.section
            )}
            style={directory ? {} : { display: "none" }}
          >
            <div className={styles.sectionArea}>
              <div
                className={classnames(styles.sectionHeader, styles.rightbtn)}
              >
                <div className={styles.headTitle}>
                  <h3>{_("Clients infos")}</h3>
                  <span>{_("Directory")}</span>
                </div>
                <a
                  href={`${TTP_HOME_URL}/folders`}
                  target="_blanck"
                  className={styles.button}
                >
                  {_("See more")}
                </a>
              </div>
              <div className={styles.sectionBody}>
                <DirectoryContainer community={community} />
              </div>
            </div>
          </div>
        </section>
        <section className="grid-x">
          <div
            className={classnames(
              "cell small-12",
              styles.section,
              styles.section12
            )}
            style={dashboard ? {} : { display: "none" }}
          >
            <div className={classnames(styles.sectionHeader, styles.rightbtn)}>
              <div className={styles.headTitle}>
                <h3>{_("Stats")}</h3>
                <span>{_("Dashboard")}</span>
              </div>
              <a
                href={TTP_ACCOUNTING_URL}
                target="_blanck"
                className={styles.button}
              >
                {_("See more")}
              </a>
            </div>
            <div className={styles.sectionBody}>
              <DashboardContainer community={community} />
            </div>
          </div>
        </section>
        <section className="grid-x">
          <div className={classnames(`cell small-12 large-6`, styles.section)}>
            <div className={styles.sectionArea}>
              <div
                className={classnames(styles.sectionHeader, styles.rightbtn)}
              >
                <div className={styles.headTitle}>
                  <h3>{_("Letterbox")}</h3>
                  <span>{_("E-box")}</span>
                </div>
                <a
                  href={TTP_EBOX_URL}
                  target="_blanck"
                  className={styles.button}
                >
                  {_("See more")}
                </a>
              </div>
              <div className={styles.sectionBody}>
                <EboxContainer community={community} />
              </div>
            </div>
          </div>
          <div className={classnames(`cell small-12 large-6`, styles.section)}>
            <div className={styles.sectionArea}>
              <div
                className={classnames(styles.sectionHeader, styles.rightbtn)}
              >
                <div className={styles.headTitle}>
                  <h3>{_("Selection of useful applications")}</h3>
                  <span>{_("Web tools")}</span>
                </div>
                <a
                  href={TTP_WEBTOOL_URL}
                  target="_blanck"
                  className={styles.button}
                >
                  {_("See more")}
                </a>
              </div>
              <WebtoolContainer community={community} />
            </div>
          </div>
        </section>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  visibleAreas: state.params.visibleAreas
});

const mapDispatchToProps = dispatch => ({
  setCurrentNavPage: page => dispatch(setCurrentNavPage(page)),
  resetResources: () => dispatch(resetResources())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkPlace);



// WEBPACK FOOTER //
// ./src/components/Community/WorkPlace/index.js